export default __webpack_public_path__ + "static/media/sinalError.a8115771.svg";